import styled from "styled-components";
import { theme } from "../theme/toyotaTheme";
import { IconWrapper } from "../globals/IconWrapper";

export const Info = styled.div`
    display: flex;
    align-items: flex-start;
    margin-bottom: ${theme.space[3]}px;
    font-family: ${theme.fonts.regular};
    font-size: 1.3rem;
    line-height: 2rem;
    color: ${theme.colors.primaryBlack};

    ${IconWrapper} {
        margin-inline-end: ${theme.space[2]}px;
    }
`;
